/**
 * PizzaGold App JS v12
 * – Inline Optionen direkt unter Produktkarte (kein Modal)
 * – Warenkorb Live-Refresh nach jeder Änderung
 * – Lieferzonen konfigurierbar (Theme-Einstellungen oder JS-Fallback)
 * – Mindestbestellwert-Sperre: Checkout blockiert bis MBW erreicht
 */
(function () {
  'use strict';

  /* ═══════════════════════════════════════════════════════
     HILFSFUNKTIONEN
  ═══════════════════════════════════════════════════════ */
  function eu(c){ return (c/100).toFixed(2).replace('.',',') + '\u00a0€'; }
  function esc(s){
    return String(s)
      .replace(/&/g,'&amp;').replace(/</g,'&lt;')
      .replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  var toastTimer;
  function showToast(msg, type){
    var el = document.getElementById('pg-toast');
    if(!el){
      el = document.createElement('div');
      el.id = 'pg-toast';
      el.style.cssText = [
        'position:fixed','bottom:84px','left:50%','transform:translateX(-50%)',
        'z-index:99999','background:#1A1209','color:#fff',
        'font-family:var(--pg-font,\'Plus Jakarta Sans\',sans-serif)',
        'font-size:14px','font-weight:700','padding:12px 22px',
        'border-radius:12px','box-shadow:0 8px 28px rgba(0,0,0,.3)',
        'pointer-events:none','white-space:nowrap','display:none',
        'border-left:4px solid #C41230','transition:opacity .2s'
      ].join(';');
      document.body.appendChild(el);
    }
    el.textContent = (type === 'success' ? '✓  ' : '⚠  ') + msg;
    el.style.borderLeftColor = type === 'success' ? '#4ade80' : '#C41230';
    el.style.display = 'block';
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function(){ el.style.display = 'none'; }, 2800);
  }

  /* ═══════════════════════════════════════════════════════
     LIEFERZONEN
  ═══════════════════════════════════════════════════════ */
  var ZONES_DEFAULT = [
    {
      name: 'Singen (Kernstadt)',
      plz: ['78224'],
      cities: ['singen'],
      minOrder: 700, deliveryCost: 150, time: '30–40 Min.'
    },
    {
      name: 'Singen – Hausen / Bohlingen / Beuren',
      plz: ['78224'],
      cities: ['hausen','hausen an der aach','friedingen','bohlingen','überlingen','überlingen am ried','beuren'],
      minOrder: 1500, deliveryCost: 200, time: '35–45 Min.'
    },
    {
      name: 'Singen – Schlatt unter Krähen',
      plz: ['78224'],
      cities: ['schlatt','schlatt unter krähen'],
      minOrder: 2000, deliveryCost: 350, time: '40–50 Min.'
    },
    {
      name: 'Hilzingen / Gottmadingen',
      plz: ['78247','78244'],
      cities: ['hilzingen','twielfeld','duchtlingen','gottmadingen'],
      minOrder: 2000, deliveryCost: 300, time: '40–55 Min.'
    },
    {
      name: 'Weiterdingen / Riedheim / Ebringen',
      plz: ['78244','78247','78135'],
      cities: ['weiterdingen','riedheim','ebringen','böhringen','bohringen'],
      minOrder: 2500, deliveryCost: 350, time: '45–60 Min.'
    },
    {
      name: 'Mühlhausen-Ehingen',
      plz: ['78259'],
      cities: ['mühlhausen','ehingen','mühlhausen-ehingen'],
      minOrder: 2500, deliveryCost: 350, time: '45–60 Min.'
    },
    {
      name: 'Bietingen / Randegg',
      plz: ['78244'],
      cities: ['bietingen','randegg'],
      minOrder: 2500, deliveryCost: 450, time: '45–60 Min.'
    },
    {
      name: 'Radolfzell',
      plz: ['78315'],
      cities: ['radolfzell'],
      minOrder: 4500, deliveryCost: 500, time: '55–70 Min.'
    }
  ];

  /* Parse zones from Theme-Settings (Textarea-Format: Name|PLZ1,PLZ2|Stadt1,Stadt2|Min€|Lieferk€|Zeit) */
  function parseZones(raw){
    if(!raw || typeof raw !== 'string' || !raw.trim()) return null;
    var out = [];
    raw.trim().split('\n').forEach(function(line){
      line = line.trim();
      if(!line || line.charAt(0) === '#') return;
      var p = line.split('|');
      if(p.length < 6) return;
      var minO = Math.round(parseFloat((p[3]||'0').replace(',','.')) * 100);
      var delC = Math.round(parseFloat((p[4]||'0').replace(',','.')) * 100);
      if(!isNaN(minO)){
        out.push({
          name:   p[0].trim(),
          plz:    p[1].trim().split(',').map(function(x){ return x.trim(); }),
          cities: p[2].trim().toLowerCase().split(',').map(function(x){ return x.trim(); }),
          minOrder: minO, deliveryCost: delC,
          time: (p[5]||'').trim()
        });
      }
    });
    return out.length ? out : null;
  }

  var ZONES;
  try {
    ZONES = parseZones(window.PG_ZONES_RAW) || ZONES_DEFAULT;
  } catch(e){ ZONES = ZONES_DEFAULT; }

  window.pgSelectedZone = null;

  function loadZone(){ try{ var z=localStorage.getItem('pgZone'); if(z) window.pgSelectedZone=JSON.parse(z); }catch(e){} }
  function saveZone(z){ window.pgSelectedZone=z; try{ localStorage.setItem('pgZone',JSON.stringify(z)); }catch(e){} }

  function searchZones(q){
    if(!q||q.length<2) return [];
    var ql = q.toLowerCase().trim();
    return ZONES.filter(function(z){
      if(z.plz.some(function(p){ return p.startsWith(ql); })) return true;
      if(z.name.toLowerCase().includes(ql)) return true;
      if(z.cities.some(function(c){ return c.includes(ql)||ql.includes(c.split(' ')[0]); })) return true;
      return false;
    });
  }

  /* ═══════════════════════════════════════════════════════
     WARENKORB AJAX + DRAWER LIVE-REFRESH
  ═══════════════════════════════════════════════════════ */
  function renderCartItem(item){
    /* Extras (pizza-belag) werden eingerückt unter der Pizza angezeigt */
    var isExtra = item.properties && item.properties['Für Pizza'];
    if(isExtra){
      var extraName = item.variant_title && item.variant_title.indexOf(' / ')>-1
        ? item.variant_title.split(' / ')[0] : (item.variant_title || item.product_title);
      return [
        '<li class="pg-cart-item pg-cart-item--belag" data-cart-item data-cart-item-key="'+esc(item.key)+'">',
          '<div style="display:flex;align-items:center;gap:6px;">',
            '<span style="font-size:12px;color:var(--pg-ink-muted);">+</span>',
            '<span style="flex:1;font-size:13px;font-weight:700;color:var(--pg-ink);">'+esc(extraName)+'</span>',
            '<span style="font-size:13px;font-weight:700;color:var(--pg-red);">'+eu(item.line_price)+'</span>',
            '<button type="button" class="pg-cart-item__remove" style="font-size:10px;padding:2px 6px;margin-left:2px;" data-cart-remove="'+esc(item.key)+'" aria-label="Entfernen">✕</button>',
          '</div>',
        '</li>'
      ].join('');
    }

    var vt = (item.variant_title && item.variant_title !== 'Default Title')
      ? '<div style="font-size:11.5px;color:var(--pg-ink-muted,#7A6E68);margin-top:2px;">'+esc(item.variant_title)+'</div>' : '';
    var props = '';
    if(item.properties){ Object.keys(item.properties).forEach(function(k){
      if(k.charAt(0)!=='_' && item.properties[k]!=='' && k!=='Für Pizza')
        props += '<div>+ '+esc(k)+(item.properties[k]!=='true'?': '+esc(item.properties[k]):'')+'</div>';
    }); }
    if(props) props = '<div class="pg-cart-item__extras">'+props+'</div>';
    return [
      '<li class="pg-cart-item" data-cart-item data-cart-item-key="'+esc(item.key)+'">',
        '<div style="display:flex;justify-content:space-between;align-items:flex-start;gap:8px;">',
          '<div style="flex:1;min-width:0;">',
            '<div class="pg-cart-item__name">'+esc(item.product_title)+'</div>',
            vt, props,
          '</div>',
          '<div class="pg-cart-item__price">'+eu(item.line_price)+'</div>',
        '</div>',
        '<div class="pg-cart-item__row">',
          '<div class="pg-cart-item__qty">',
            '<button type="button" class="pg-cart-item__qty-btn" data-cart-qty-minus="'+esc(item.key)+'" aria-label="Weniger">\u2212</button>',
            '<span class="pg-cart-item__qty-val" data-cart-qty="'+esc(item.key)+'">'+item.quantity+'</span>',
            '<button type="button" class="pg-cart-item__qty-btn" data-cart-qty-plus="'+esc(item.key)+'" aria-label="Mehr">+</button>',
          '</div>',
          '<button type="button" class="pg-cart-item__remove" data-cart-remove="'+esc(item.key)+'">Entfernen</button>',
        '</div>',
      '</li>'
    ].join('');
  }

  /* Extras direkt nach ihrer Eltern-Pizza einsortieren */
  function pgGroupCartItems(items){
    var extras = items.filter(function(i){ return i.properties && i.properties['F\xfcr Pizza']; });
    var main   = items.filter(function(i){ return !(i.properties && i.properties['F\xfcr Pizza']); });
    var used   = [];
    var result = [];
    main.forEach(function(item){
      result.push(item);
      var vt  = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
      var key = item.product_title + (vt ? ' – ' + vt : '');
      extras.forEach(function(e){
        if(used.indexOf(e) < 0 && e.properties['F\xfcr Pizza'] === key){
          result.push(e); used.push(e);
        }
      });
    });
    /* Nicht zugeordnete Extras ans Ende */
    extras.forEach(function(e){ if(used.indexOf(e) < 0) result.push(e); });
    return result;
  }

  var _pgLastCart = null;

    function refreshCartDrawer(cart){
    _pgLastCart = cart;
    var list    = document.querySelector('[data-cart-items]');
    var drawer  = document.querySelector('[data-cart]');
    var countEl = document.querySelector('[data-cart-item-count]');
    if(drawer) drawer.classList.toggle('is-empty', cart.item_count===0);
    if(list)   list.innerHTML = cart.items.length ? pgGroupCartItems(cart.items).map(renderCartItem).join('') : '';
    if(countEl){
      countEl.textContent = cart.item_count + ' Artikel';
      countEl.style.display = cart.item_count > 0 ? '' : 'none';
    }
    updateCartCounts(cart);
  }

  /* Extras für ein Pizza-Cart-Item anhand des pizzaKey finden */
  function pgExtrasForCartItem(item){
    if(!_pgLastCart) return [];
    var vt  = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
    var key = item.product_title + (vt ? ' – ' + vt : '');
    return _pgLastCart.items.filter(function(i){
      return i.properties && i.properties['F\xfcr Pizza'] === key;
    });
  }

  /* Qty-Änderung mit Extras synchronisieren via /cart/update.js */
  function pgCartChangeWithSync(targetKey, newQty){
    var item = _pgLastCart && _pgLastCart.items.find(function(i){ return i.key === targetKey; });
    /* Kein Eintrag gefunden oder selbst ein Extra → normal ändern */
    if(!item || (item.properties && item.properties['F\xfcr Pizza'])){
      cartChange(targetKey, newQty);
      return;
    }
    var extras = pgExtrasForCartItem(item);
    if(!extras.length){ cartChange(targetKey, newQty); return; }

    /* Alle auf einmal updaten */
    var updates = {};
    updates[targetKey] = newQty;
    extras.forEach(function(e){ updates[e.key] = newQty; });
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
    .then(function(r){ return r.json(); })
    .then(refreshCartDrawer)
    .catch(function(){ cartChange(targetKey, newQty); });
  }

  /* skipRender=true: NICHT sofort neu rendern. Wird genutzt, wenn direkt danach
     noch Extras hinzugefügt werden — sonst rendert der Drawer ZUERST die Pizza
     OHNE ihre Extras (ungruppiert/unvollständig) und erst der zweite Render
     korrigiert es. Schlägt der zweite Render fehl/verzögert, bleibt der falsche
     Stand bis zum Reload stehen. Mit skipRender wird nur EINMAL gerendert –
     nachdem Pizza UND Extras im Cart sind. */
  function addToCart(variantId, qty, onDone, props, skipRender){
    var payload = { id: parseInt(variantId), quantity: qty||1 };
    if(props && Object.keys(props).length) payload.properties = props;
    fetch('/cart/add.js', {
      method:'POST',
      headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
      body: JSON.stringify(payload)
    })
    .then(function(r){ return r.json(); })
    .then(function(){
      fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
        if(!skipRender) refreshCartDrawer(cart);
        if(onDone) onDone(cart);
      });
    })
    .catch(function(e){ console.error('[PG] addToCart error:', e); showToast('Fehler beim Hinzufügen'); });
  }

  function cartChange(key, qty){
    fetch('/cart/change.js', {
      method:'POST',
      headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function(r){ return r.json(); })
    .then(refreshCartDrawer)
    .catch(function(e){ console.error('[PG] cartChange error:', e); });
  }

  function updateCartCounts(cart){
    var minCents = window.pgSelectedZone ? window.pgSelectedZone.minOrder : (ZONES[0] ? ZONES[0].minOrder : 700);

    /* Header badge */
    var badge = document.querySelector('[data-cart-count]');
    if(badge){ badge.textContent=cart.item_count; badge.style.display=cart.item_count>0?'flex':'none'; }
    var totalEl = document.querySelector('[data-cart-total]');
    if(totalEl) totalEl.textContent = eu(cart.total_price);

    /* Cart drawer total */
    var priceEl = document.querySelector('[data-cart-price]');
    if(priceEl) priceEl.textContent = eu(cart.total_price);
    /* Preis im Checkout-Button */
    var btnPrice = document.querySelector('[data-checkout-price]');
    if(btnPrice) btnPrice.textContent = eu(cart.total_price);

    /* Min-Order Bar + Erreicht-Zustand + Checkout-Blocking */
    var bar      = document.getElementById('pg-min-order-bar');
    var reached  = document.getElementById('pg-min-order-reached');
    var chk      = document.querySelector('[data-checkout-button]');
    if(bar){
      if(cart.item_count > 0){
        var rem = Math.max(0, minCents - cart.total_price);
        var pct = Math.min(100, (cart.total_price / minCents) * 100);
        if(rem > 0){
          bar.style.display = '';
          if(reached) reached.style.display = 'none';
          var txt = bar.querySelector('.pg-cart-progress__text');
          if(txt) txt.innerHTML = 'Noch <strong>'+eu(rem)+'</strong> bis zur Bestellung';
          var fill = bar.querySelector('.pg-cart-progress__fill');
          if(fill) fill.style.width = pct + '%';
          if(chk){ chk.disabled = true; chk.classList.add('pg-checkout-blocked'); }
          var hint=document.getElementById('pg-checkout-hint'); if(hint) hint.style.display='';
        } else {
          bar.style.display = 'none';
          var s = window.pgDelivery ? window.pgDelivery.getStatus() : null;
          var shopOpen = !s || s.open;
          /* Vorbestellung: erlaubt Checkout auch bei geschlossenem Laden, wenn eine Wunschzeit gewählt ist */
          var pre = window.pgPreorder || { mode:'now', time:'' };
          var canCheckout = (pre.mode === 'later' && pre.time) ? true : shopOpen;
          if(reached) reached.style.display = canCheckout ? 'flex' : 'none';
          if(chk){ chk.disabled = !canCheckout; chk.classList.remove('pg-checkout-blocked'); }
          var hint2=document.getElementById('pg-checkout-hint');
          if(hint2){
            if(!canCheckout && !shopOpen){ hint2.textContent='Aktuell geschlossen — wähle „Für später" zum Vorbestellen'; hint2.style.display=''; }
            else { hint2.style.display='none'; }
          }
        }
      } else {
        bar.style.display = 'none';
        if(reached) reached.style.display = 'none';
        if(chk){ chk.disabled = true; chk.classList.remove('pg-checkout-blocked'); }
      }
    }

    /* Zone-Anzeige via updateZoneDisplay() */
    updateZoneDisplay();
  }
  /* Checkout-Status neu bewerten (z.B. nach Vorbestell-Auswahl) */
  window.pgUpdateCheckout = function(){
    if(_pgLastCart){ updateCartCounts(_pgLastCart); return; }
    fetch('/cart.js').then(function(r){return r.json();}).then(function(c){ _pgLastCart=c; updateCartCounts(c); }).catch(function(){});
  };

  /* ═══════════════════════════════════════════════════════
     DIREKT HINZUFÜGEN (einfache Produkte, kein Variant)
  ═══════════════════════════════════════════════════════ */
  window.pgDirectAdd = function(btn, variantId, title){
    if(!btn||btn.disabled) return;
    btn.disabled = true; btn.innerHTML = '\u2026';
    addToCart(variantId, 1, function(){
      btn.innerHTML = '\u2713'; btn.style.background = '#166534';
      showToast(decodeURIComponent(title)+' hinzugefügt', 'success');
      setTimeout(function(){ btn.innerHTML='+'; btn.style.background=''; btn.disabled=false; }, 1800);
    });
  };

  /* ═══════════════════════════════════════════════════════
     OPTIONEN MODAL — Bottom-Sheet / Popup
  ═══════════════════════════════════════════════════════ */
  function findVariant(product, selected){
    return product.variants.find(function(v){
      return product.options.every(function(opt,i){
        var name = typeof opt === 'string' ? opt : String(opt.name || opt);
        return v['option'+(i+1)] === selected[name];
      });
    });
  }

  var _pgOptQty = 1;
  var _pgOptSel = {};
  var _pgOptExtras = [];
  var _pgExtrasProduct = null;

  function pgCloseOptModal(){
    var m = document.getElementById('pg-opt-modal');
    if(m) m.style.display = 'none';
    document.body.style.overflow = '';
    _pgOptQty = 1; _pgOptSel = {}; _pgOptExtras = []; _pgExtrasProduct = null;
  }

  window.pgOpenOptionsModal = function(handle){
    var modal   = document.getElementById('pg-opt-modal');
    var loading = document.getElementById('pg-opt-loading');
    var content = document.getElementById('pg-opt-content');
    if(!modal){ return; }

    _pgOptQty = 1; _pgOptExtras = []; _pgExtrasProduct = null;
    if(loading) loading.style.display = 'block';
    if(content) content.style.display = 'none';
    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';

    var extHandle = (window.pgMenuConfig||{}).extrasProductHandle||'pizza-belag-extra';
    Promise.all([
      fetch('/products/'+handle+'.js').then(function(r){ if(!r.ok) throw new Error(r.status); return r.json(); }),
      fetch('/products/'+extHandle+'.js').then(function(r){ return r.json(); }).catch(function(){ return null; })
    ])
      .then(function(res){
        pgBuildOptModal(res[0], res[1]);
        if(loading) loading.style.display = 'none';
        if(content) content.style.display = 'flex';
      })
      .catch(function(e){
        console.error('[PG] Modal:', e);
        pgCloseOptModal();
        showToast('Produkt konnte nicht geladen werden');
      });
  };

  /* Größe aus Varianten-Wert extrahieren */
  function pgExtractSize(val){
    var v=(val||'').toLowerCase();
    if(v.indexOf('klein')>-1) return 'Klein';
    if(v.indexOf('famil')>-1) return 'Familie';
    if(v.indexOf('party')>-1) return 'Party';
    if(v.indexOf('gro')>-1)   return 'Groß';
    return null;
  }

  /* Extra-Variante für aktuell gewählte Größe finden */
  function pgFindExtraVariant(toppingName){
    if(!_pgExtrasProduct) return null;
    var size = null;
    Object.keys(_pgOptSel).forEach(function(k){
      if(!size) size = pgExtractSize(_pgOptSel[k]);
    });
    size = size || 'Klein';
    var nameLC = toppingName.trim().toLowerCase();
    var sizeLC = size.trim().toLowerCase();
    return _pgExtrasProduct.variants.find(function(v){
      return (v.option1||'').trim().toLowerCase() === nameLC
          && (v.option2||'').trim().toLowerCase() === sizeLC;
    }) || null;
  }

  /* Aktuelle Größe aus _pgOptSel lesen */
  function pgCurrentSize(){
    var size = null;
    Object.keys(_pgOptSel).forEach(function(k){
      if(!size) size = pgExtractSize(_pgOptSel[k]);
    });
    return size || 'Klein';
  }

  /* Preise aller Extras-Kacheln auf aktuelle Größe aktualisieren */
  function pgRefreshExtrasTiles(){
    var grid = document.getElementById('pg-opt-extras-grid');
    if(!grid) return;
    var size = pgCurrentSize();
    var ec = (window.pgMenuConfig||{}).pizzaExtras||[];
    grid.querySelectorAll('.pg-extra-tile').forEach(function(tile){
      var name = tile.dataset.extraName;
      if(!name) return;
      /* Preis aus Config (Größen-abhängig) */
      var cfg = ec.find(function(e){ return e.name === name; });
      var cents = cfg ? ((cfg.prices && cfg.prices[size]) ? cfg.prices[size] : cfg.price) : 0;
      /* Shopify-Variant-ID für späteres Cart-Add merken */
      if(_pgExtrasProduct){
        var v = pgFindExtraVariant(name);
        if(v){
          tile.dataset.variantId = v.id;
          cents = v.price; /* Shopify Ajax API gibt Preise bereits in Cent zurück */
        }
      }
      var priceEl = tile.querySelector('.pg-extra-tile__price');
      if(priceEl) priceEl.textContent = '+'+eu(cents);
      tile.dataset.price = cents;
    });
  }

    function pgBuildOptModal(product, extrasProduct){
    _pgExtrasProduct = extrasProduct || null;
    var titleEl  = document.getElementById('pg-opt-title');
    var vendorEl = document.getElementById('pg-opt-vendor');
    var descEl   = document.getElementById('pg-opt-desc');
    var body     = document.getElementById('pg-opt-body');
    var addBtn   = document.getElementById('pg-opt-add-btn');
    var addLbl   = document.getElementById('pg-opt-add-label');
    var priceEl  = document.getElementById('pg-opt-price');
    var qtyVal   = document.getElementById('pg-opt-qty-val');
    var qtyMinus = document.getElementById('pg-opt-qty-minus');
    var qtyPlus  = document.getElementById('pg-opt-qty-plus');

    if(titleEl)  titleEl.textContent  = product.title;
    if(vendorEl) vendorEl.textContent = product.vendor || '';
    if(descEl)   descEl.textContent   = product.description
      ? product.description.replace(/<[^>]+>/g,'').substring(0,120) : '';
    if(body) body.innerHTML = '';
    _pgOptQty = 1;
    if(qtyVal) qtyVal.textContent = '1';

    var firstAvail = product.variants.find(function(v){ return v.available; }) || product.variants[0];
    /* Shopify .js API kann options als Strings ODER Objekte zurückgeben */
    var optNames = product.options.map(function(o){
      return typeof o === 'string' ? o : String(o.name || o);
    });
    _pgOptSel = {};
    optNames.forEach(function(name,i){ _pgOptSel[name] = firstAvail['option'+(i+1)]; });

    optNames.forEach(function(optName, optIdx){
      var values = [];
      product.variants.forEach(function(v){
        var val = v['option'+(optIdx+1)];
        if(values.indexOf(val)<0) values.push(val);
      });
      if(values.length===1 && values[0]==='Default Title') return;

      var group = document.createElement('div');
      group.className = 'pg-opt-group';

      var lbl = document.createElement('div');
      lbl.className = 'pg-opt-group-label';
      lbl.textContent = optName;
      group.appendChild(lbl);

      var pillWrap = document.createElement('div');
      pillWrap.className = 'pg-opt-pills';

      values.forEach(function(val){
        var testSel = {}; Object.assign(testSel, _pgOptSel); testSel[optName] = val;
        var testV   = findVariant(product, testSel);
        var soldOut = testV && !testV.available;
        var isActive = val === _pgOptSel[optName];

        var pill = document.createElement('button');
        pill.type = 'button';
        pill.textContent = val;
        pill.dataset.optVal = val;
        pill.className = 'pg-opt-pill'
          + (isActive ? ' pg-opt-pill--active'  : '')
          + (soldOut  ? ' pg-opt-pill--unavail' : '');

        pill.addEventListener('click', function(){
          if(soldOut) return;
          _pgOptSel[optName] = val;
          pillWrap.querySelectorAll('.pg-opt-pill').forEach(function(p){
            p.classList.toggle('pg-opt-pill--active', p.dataset.optVal === val);
          });
          pgRefreshOptModal(product);
        });
        pillWrap.appendChild(pill);
      });
      group.appendChild(pillWrap);
      if(body) body.appendChild(group);
    });

    /* \u2500\u2500 Extras-Bereich f\u00fcr Pizzen \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */
    var pizzaSizes = ['klein','gro\u00df','gross','familie','party'];
    var isPizza = product.variants.some(function(v){
      return pizzaSizes.some(function(s){ return (v.option1||'').toLowerCase().indexOf(s)>-1; });
    });
    _pgOptExtras = [];
    if(isPizza && body){
      var extrasCfg = (window.pgMenuConfig||{}).pizzaExtras||[];
      if(extrasCfg.length){
        var sep = document.createElement('div');
        sep.style.cssText = 'border-top:1px solid var(--pg-border,#E8E0D8);margin:16px 0 10px;';
        body.appendChild(sep);

        var extLbl = document.createElement('div');
        extLbl.className = 'pg-extras-section-label';
        extLbl.innerHTML = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>\u00a0Extras zubuchbar';
        body.appendChild(extLbl);

        var extGrid = document.createElement('div');
        extGrid.className = 'pg-extras-grid';
        extGrid.id = 'pg-opt-extras-grid';

        extrasCfg.forEach(function(extra){
          var tile = document.createElement('div');
          tile.className = 'pg-extra-tile';
          tile.dataset.extraName = extra.name;
          tile.dataset.price     = extra.price;
          tile.innerHTML = '<div class="pg-extra-tile__check">\u2713</div>'
            +'<div class="pg-extra-tile__name">'+extra.name+'</div>'
            +'<div class="pg-extra-tile__price">+'+eu(extra.price)+'</div>';
          tile.addEventListener('click', function(){
            var idx = _pgOptExtras.indexOf(extra.name);
            if(idx>-1){ _pgOptExtras.splice(idx,1); tile.classList.remove('pg-extra-tile--selected'); }
            else { _pgOptExtras.push(extra.name); tile.classList.add('pg-extra-tile--selected'); }
            pgRefreshOptModal(product);
          });
          extGrid.appendChild(tile);
        });
        body.appendChild(extGrid);
      }
    }
    /* \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */

    if(qtyMinus) qtyMinus.onclick = function(){
      _pgOptQty = Math.max(1, _pgOptQty-1);
      if(qtyVal) qtyVal.textContent = _pgOptQty;
      pgRefreshOptModal(product);
    };
    if(qtyPlus) qtyPlus.onclick = function(){
      _pgOptQty = Math.min(20, _pgOptQty+1);
      if(qtyVal) qtyVal.textContent = _pgOptQty;
      pgRefreshOptModal(product);
    };

    if(addBtn){
      addBtn.onclick = function(){
        var vid = parseInt(addBtn.dataset.variantId||'0');
        if(!vid || addBtn.disabled) return;
        addBtn.disabled = true;
        if(addLbl) addLbl.textContent = '\u2026 Wird hinzugef\xfcgt';
        /* Werte sofort sichern — _pgOptQty/_pgOptExtras können durch Modal-Schließen resettet werden */
        var snapQty    = _pgOptQty;
        var snapExtras = _pgOptExtras.slice();
        var selVariant = findVariant(product, _pgOptSel);
        var vt         = selVariant && selVariant.title !== 'Default Title' ? selVariant.title : '';
        var pizzaKey   = product.title + (vt ? ' – ' + vt : '');
        var pizzaProps = snapExtras.length ? { '_uid': Date.now() } : null;

        addToCart(vid, snapQty, function(cartAfterPizza){
          if(!snapExtras.length){
            refreshCartDrawer(cartAfterPizza);   /* keine Extras → jetzt rendern */
            pgCloseOptModal();
            showToast(product.title+' hinzugef\xfcgt', 'success');
            return;
          }
          var grid  = document.getElementById('pg-opt-extras-grid');
          var items = [];
          snapExtras.forEach(function(name){
            var tile  = grid ? grid.querySelector('[data-extra-name="'+name+'"]') : null;
            var varId = tile ? parseInt(tile.dataset.variantId||'0') : 0;
            if(varId) items.push({ id: varId, quantity: snapQty, properties: { 'F\xfcr Pizza': pizzaKey } });
          });
          if(!items.length){ refreshCartDrawer(cartAfterPizza); pgCloseOptModal(); showToast(product.title+' hinzugef\xfcgt', 'success'); return; }
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
          })
          .then(function(){ return fetch('/cart.js'); })
          .then(function(r){ return r.json(); })
          .then(function(cart){ refreshCartDrawer(cart); document.dispatchEvent(new CustomEvent('cart:updated')); pgCloseOptModal(); showToast(product.title+' hinzugef\xfcgt', 'success'); })
          .catch(function(){ document.dispatchEvent(new CustomEvent('cart:updated')); pgCloseOptModal(); showToast(product.title+' hinzugef\xfcgt', 'success'); });
        }, pizzaProps, true);   /* skipRender: erst nach dem Extra-Add rendern (vollständig + gruppiert) */
      };
    }

    pgRefreshOptModal(product);
  }

  function pgRefreshOptModal(product){
    var addBtn     = document.getElementById('pg-opt-add-btn');
    var priceEl    = document.getElementById('pg-opt-price');
    var addLbl     = document.getElementById('pg-opt-add-label');
    var unavailMsg = document.getElementById('pg-opt-unavail-msg');
    var closedNote = document.getElementById('pg-opt-closed-note');
    var variant    = findVariant(product, _pgOptSel);

    if(!variant || !addBtn){ if(addBtn) addBtn.disabled=true; return; }
    addBtn.dataset.variantId = variant.id;
    /* Größen-abhängige Extras-Preise aktualisieren */
    pgRefreshExtrasTiles();
    var extrasSum = 0;
    var extGrid2 = document.getElementById('pg-opt-extras-grid');
    if(extGrid2) extGrid2.querySelectorAll('.pg-extra-tile--selected').forEach(function(t){
      extrasSum += parseInt(t.dataset.price||'0');
    });
    if(priceEl) priceEl.textContent = eu((variant.price + extrasSum) * _pgOptQty);

    var shopOpen = !window.pgDelivery || window.pgDelivery.getStatus().open;
    var avail = variant.available;
    addBtn.disabled = !avail || !shopOpen;
    addBtn.style.background = avail ? 'var(--pg-red,#C41230)' : 'var(--pg-ink-muted,#7A6E68)';
    if(unavailMsg) unavailMsg.style.display = avail ? 'none' : 'block';
    if(closedNote) closedNote.style.display = (avail && !shopOpen) ? 'block' : 'none';
    if(addLbl) addLbl.textContent = 'In den Warenkorb';
  }

  function initOptModal(){
    var closeBtn = document.getElementById('pg-opt-close');
    var backdrop = document.getElementById('pg-opt-bd');
    if(closeBtn) closeBtn.addEventListener('click', pgCloseOptModal);
    if(backdrop) backdrop.addEventListener('click', pgCloseOptModal);
    document.addEventListener('keydown', function(e){
      if(e.key === 'Escape'){
        var m = document.getElementById('pg-opt-modal');
        if(m && m.style.display !== 'none') pgCloseOptModal();
      }
    });
  }

  /* ═══════════════════════════════════════════════════════
     ZONEN-MODAL
  ═══════════════════════════════════════════════════════ */
  window.pgOpenZone = function(){
    var modal = document.getElementById('pg-zone-modal');
    if(modal){ modal.style.display='flex'; document.body.style.overflow='hidden';
      var inp = document.getElementById('pg-zone-input');
      if(inp) setTimeout(function(){ inp.focus(); }, 150); }
  };
  window.pgCloseZone = function(){
    var modal = document.getElementById('pg-zone-modal');
    if(modal){ modal.style.display='none'; document.body.style.overflow=''; }
  };

  function applyZone(zone){
    saveZone(zone);
    updateZoneDisplay();
    window.pgCloseZone();
    showToast('📍 Liefergebiet: '+zone.name, 'success');
    fetch('/cart.js').then(function(r){ return r.json(); }).then(updateCartCounts).catch(function(){});
  }

  function updateZoneDisplay(){
    var zone = window.pgSelectedZone;

    /* Status-Bar Zone-Chip (Desktop) */
    var chip = document.getElementById('pg-zone-chip-label');
    if(chip && zone) chip.textContent = zone.name.split(' ')[0].replace('–','').trim();
    var chipWrap = document.getElementById('pg-zone-chip-wrap');
    if(chipWrap) chipWrap.style.display = zone ? 'inline-flex' : 'none';

    /* Hero Info-Strip */
    var heroZone = document.getElementById('pg-hero-zone-name');
    if(heroZone) heroZone.textContent = zone ? zone.name.split(' ')[0].replace('–','').trim() : 'Ort wählen';
    var heroMin = document.getElementById('pg-hero-min-order-val');
    if(heroMin) heroMin.textContent = zone ? 'ab '+eu(zone.minOrder) : 'ab –';
    var heroD = document.getElementById('pg-hero-delivery-val');
    if(heroD) heroD.textContent = zone ? eu(zone.deliveryCost) : '–';
    var heroT = document.getElementById('pg-hero-time-val');
    if(heroT && zone && zone.time) heroT.textContent = zone.time;

    /* Cart-Drawer Zone */
    var cartZone = document.getElementById('pg-cart-zone-name');
    if(cartZone) cartZone.textContent = zone ? zone.name : '–';
    var cartMin = document.getElementById('pg-cart-min-display');
    if(cartMin) cartMin.textContent = zone ? 'ab '+eu(zone.minOrder) : '📦 Ort wählen';
    var cartDel = document.getElementById('pg-cart-del-display');
    if(cartDel) cartDel.textContent = zone ? 'Lieferk. '+eu(zone.deliveryCost) : '';
  }

  function initZoneModal(){
    loadZone();
    updateZoneDisplay();

    var inp = document.getElementById('pg-zone-input');
    var results = document.getElementById('pg-zone-results');
    var pendingZone = null;

    if(inp && results){
      inp.addEventListener('input', function(){
        var matches = searchZones(inp.value);
        pendingZone = null;
        var selBox = document.getElementById('pg-zone-selected');
        if(selBox) selBox.style.display = 'none';

        if(!matches.length){
          results.innerHTML = inp.value.length > 1
            ? '<div class="pg-zone-result-item pg-zone-result-item--none">Kein Liefergebiet gefunden für "'+esc(inp.value)+'"</div>'
            : '';
          return;
        }
        results.innerHTML = '';
        matches.forEach(function(zone){
          var item = document.createElement('div');
          item.className = 'pg-zone-result-item';
          item.innerHTML =
            '<div><div class="pg-zone-result-name">'+esc(zone.name)+'</div>'+
            '<div class="pg-zone-result-plz">PLZ: '+esc(zone.plz.join(', '))+
            ' &nbsp;·&nbsp; Lieferzeit: '+esc(zone.time)+'</div></div>'+
            '<div style="text-align:right;flex-shrink:0;">'+
              '<div class="pg-zone-result-min">ab '+eu(zone.minOrder)+'</div>'+
              '<div style="font-size:10.5px;color:var(--pg-ink-muted,#7A6E68);margin-top:2px;">+ '+eu(zone.deliveryCost)+' Lieferkosten</div>'+
            '</div>';
          item.addEventListener('click', function(){
            pendingZone = zone;
            results.querySelectorAll('.pg-zone-result-item--active').forEach(function(a){ a.classList.remove('pg-zone-result-item--active'); });
            item.classList.add('pg-zone-result-item--active');
            var sn = document.getElementById('pg-zone-selected-name');
            var si = document.getElementById('pg-zone-selected-info');
            if(selBox) selBox.style.display = 'block';
            if(sn) sn.textContent = zone.name;
            if(si) si.textContent = 'Mindest. '+eu(zone.minOrder)+' · Lieferkosten '+eu(zone.deliveryCost)+' · '+zone.time;
          });
          results.appendChild(item);
        });
      });
    }

    var confirmBtn = document.getElementById('pg-zone-confirm');
    if(confirmBtn) confirmBtn.addEventListener('click', function(){ if(pendingZone) applyZone(pendingZone); });

    var skipBtn = document.getElementById('pg-zone-skip');
    if(skipBtn) skipBtn.addEventListener('click', window.pgCloseZone);

    var bd = document.getElementById('pg-zone-bd');
    if(bd) bd.addEventListener('click', window.pgCloseZone);

    var chip = document.getElementById('pg-zone-chip-wrap');
    if(chip) chip.addEventListener('click', window.pgOpenZone);

    /* Nur beim ersten Besuch öffnen — danach zeigt der Zone-Chip die gespeicherte Zone */
    if(!window.pgSelectedZone) window.pgOpenZone();
  }

  /* ═══════════════════════════════════════════════════════
     ÖFFNUNGSZEITEN / STATUS BAR
  ═══════════════════════════════════════════════════════ */
  var SCHEDULE = {
    0:[{o:'12:00',c:'23:00'}], 1:[], 2:[{o:'15:00',c:'23:00'}],
    3:[{o:'15:00',c:'23:00'}], 4:[{o:'15:00',c:'23:00'}],
    5:[{o:'15:00',c:'23:00'}], 6:[{o:'15:00',c:'23:00'}]
  };
  var DAYS = ['Sonntag','Montag','Dienstag','Mittwoch','Donnerstag','Freitag','Samstag'];

  function getBerlin(){ return new Date(new Date().toLocaleString('en-US',{timeZone:'Europe/Berlin'})); }
  function toMin(t){ var p=t.split(':'); return +p[0]*60+ +p[1]; }
  function uhr(t){ return t+'\u00a0Uhr'; }

  function getStatus(){
    /* Test-Modus: immer geöffnet */
    if(window.PG_TEST_MODE) return {open:true,closeTime:'23:59',testMode:true};
    /* Harte Notfall-Schließung aus dem Theme-Editor (settings.store_force_closed).
       Hat IMMER Vorrang — auch vor dem Live-Status. */
    if(window.PG_FORCE_CLOSED) return {open:false,reason:'force_closed'};
    /* LIVE-STATUS vom Printer-Server (Tablet-Schalter) ist maßgeblich, sobald
       vorhanden — er öffnet UND schließt. Der statische Fahrplan unten greift
       nur noch als Fallback, wenn der Server nicht erreichbar ist.
       „Online am Tablet" heißt damit wirklich „offen auf der Seite". */
    if(typeof window.PG_LIVE_OPEN === 'boolean'){
      if(!window.PG_LIVE_OPEN) return {open:false,reason:'server_closed'};
      /* offen laut Server → Bestellschluss aus dem Fahrplan ableiten, sonst 23:00 */
      var lt=getBerlin(),ld=lt.getDay(),lcm=lt.getHours()*60+lt.getMinutes();
      var lslots=SCHEDULE[ld]||[],lct='';
      for(var li=0;li<lslots.length;li++){ if(lcm<toMin(lslots[li].c)){ lct=lslots[li].c; break; } }
      if(!lct && lslots.length) lct=lslots[lslots.length-1].c;
      return {open:true,closeTime:lct||'23:00',live:true};
    }
    var t=getBerlin(),d=t.getDay(),cm=t.getHours()*60+t.getMinutes();
    var slots=SCHEDULE[d];
    if(!slots||!slots.length) return {open:false,reason:'day_closed'};
    for(var i=0;i<slots.length;i++){
      if(cm>=toMin(slots[i].o)&&cm<toMin(slots[i].c)) return {open:true,closeTime:slots[i].c};
    }
    if(slots[0]&&cm<toMin(slots[0].o)) return {open:false,reason:'before_open',openTime:slots[0].o};
    return {open:false,reason:'after_close'};
  }
  function getNextOpen(){
    var t=getBerlin(),cd=t.getDay(),cm=t.getHours()*60+t.getMinutes();
    var ts=SCHEDULE[cd];
    if(ts) for(var i=0;i<ts.length;i++) if(toMin(ts[i].o)>cm) return {label:'heute',time:ts[i].o};
    for(var j=1;j<=7;j++){ var nd=(cd+j)%7; if(SCHEDULE[nd]&&SCHEDULE[nd].length) return {label:j===1?'morgen':DAYS[nd],time:SCHEDULE[nd][0].o}; }
    return null;
  }

  /* Verfügbare Vorbestell-Slots für die nächsten Tage (alle 15 Min., mit Vorlaufzeit).
     PG_PREORDER_LEAD_MIN = Vorlaufzeit in Minuten (Default 120 = 2 Std.)
     PG_PREORDER_DAYS     = wie viele Tage im Voraus (Default 3) */
  function getSlots(leadMin){
    leadMin = leadMin || window.PG_PREORDER_LEAD_MIN || 120;
    var maxDays = window.PG_PREORDER_DAYS || 3;
    var now = getBerlin();
    var step = 15;
    var out = [];
    for(var off=0; off<maxDays && out.length<48; off++){
      var dd = (now.getDay()+off)%7;
      var daySlots = SCHEDULE[dd];
      if(!daySlots || !daySlots.length) continue;
      var dayLabel = off===0 ? 'Heute' : off===1 ? 'Morgen' : DAYS[dd];
      for(var w=0; w<daySlots.length; w++){
        var start = toMin(daySlots[w].o);
        var end   = toMin(daySlots[w].c);
        if(off===0){
          var earliest = now.getHours()*60 + now.getMinutes() + leadMin;
          earliest = Math.ceil(earliest/step)*step;
          if(earliest > start) start = earliest;
        }
        for(var m=start; m<=end-step; m+=step){
          var hh=Math.floor(m/60), mm=m%60;
          var t=(hh<10?'0':'')+hh+':'+(mm<10?'0':'')+mm;
          out.push({ value: dayLabel+' '+t+' Uhr', label: dayLabel+', '+t+' Uhr' });
        }
      }
    }
    return out;
  }

  window.pgPreorder = { mode:'now', time:'' };
  window.pgDelivery = { getStatus:getStatus, getNextOpen:getNextOpen, getSlots:getSlots };

  function updateStatusBar(){
    var bar=document.getElementById('pg-status-bar');
    if(!bar) return;
    var s=getStatus();
    bar.className='pg-status-bar '+(s.open?'pg-status-bar--open':'pg-status-bar--closed');
    var pulse=document.getElementById('pg-pulse');
    if(pulse) pulse.className='pg-pulse '+(s.open?'pg-pulse--open':'pg-pulse--closed');
    var label=document.getElementById('pg-status-label');
    if(label) label.textContent=s.testMode?'🧪 Test-Modus – wir liefern!':s.reason==='force_closed'?(window.PG_FORCE_CLOSED_MSG||'Vorübergehend geschlossen'):s.open?'Jetzt geöffnet – wir liefern!':'Aktuell geschlossen';
    var info=document.getElementById('pg-status-info');
    if(info){
      if(s.open) info.textContent='Bestellschluss '+uhr(s.closeTime);
      else if(s.reason==='before_open') info.textContent='Öffnet heute um '+uhr(s.openTime);
      else{ var nx=getNextOpen(); info.textContent=nx?'Öffnet '+nx.label+' um '+uhr(nx.time):''; }
    }
    var todayEl=document.getElementById('pg-status-today');
    if(todayEl){
      var slots=SCHEDULE[getBerlin().getDay()]||[];
      todayEl.textContent=slots.length?'Heute: '+slots.map(function(x){return x.o+'–'+x.c+' Uhr';}).join(' & '):'Heute geschlossen';
    }
    var cchip=document.getElementById('pg-cart-status-chip');
    if(cchip) cchip.textContent=s.open?'🟢 Geöffnet':'🔴 Geschlossen';
    var cnotice=document.getElementById('pg-cart-closed-notice');
    if(cnotice) cnotice.style.display=s.open?'none':'block';
    s.open?document.body.classList.remove('pg-shop-closed'):document.body.classList.add('pg-shop-closed');
  }

  /* ═══════════════════════════════════════════════════════
     KATEGORIE-TABS
  ═══════════════════════════════════════════════════════ */
  function initCatTabs(){
    var scroller=document.getElementById('pg-cattabs-scroller');
    if(!scroller) return;
    var tabs=Array.from(scroller.querySelectorAll('[data-cat]'));
    var sections=Array.from(document.querySelectorAll('.pg-cat-section[data-section-id]'));
    if(!sections.length) return;
    function setActive(id){ tabs.forEach(function(t){ t.classList.toggle('pg-cattabs__link--active',t.getAttribute('data-cat')===id); }); var at=scroller.querySelector('[data-cat="'+id+'"]'); if(at) at.scrollIntoView({behavior:'smooth',inline:'center',block:'nearest'}); }
    function getActive(){
      var hdr=document.getElementById('pg-site-header');
      var sb=document.getElementById('pg-status-bar');
      var cats=document.getElementById('pg-cattabs');
      var off=(hdr?hdr.offsetHeight:52)+(sb?sb.offsetHeight:36)+(cats?cats.offsetHeight:48)+10;
      var thr=window.scrollY+off;
      var act=sections[0].id;
      for(var i=0;i<sections.length;i++){
        if(sections[i].getBoundingClientRect().top+window.scrollY<=thr){ act=sections[i].id; }
        else{ break; }
      }
      return act;
    }
    var _tick=false;
    function onScroll(){
      if(!_tick){ requestAnimationFrame(function(){ setActive(getActive()); _tick=false; }); _tick=true; }
    }
    window.addEventListener('scroll',onScroll,{passive:true});
    tabs.forEach(function(tab){ tab.addEventListener('click',function(e){ e.preventDefault(); e.stopPropagation(); var id=tab.getAttribute('data-cat'); var target=document.getElementById(id); if(!target) return; var hdr=document.getElementById('pg-site-header'); var statusBar=document.getElementById('pg-status-bar'); var cats=document.getElementById('pg-cattabs'); var off=(hdr?hdr.offsetHeight:52)+(statusBar?statusBar.offsetHeight:36)+(cats?cats.offsetHeight:48)+6; var pos=Math.max(0,target.getBoundingClientRect().top+window.scrollY-off); try{window.scrollTo({top:pos,behavior:'smooth'});}catch(err){window.scrollTo(0,pos);} setActive(id); }); });
    if(tabs.length) setActive(tabs[0].getAttribute('data-cat'));
  }

  /* ═══════════════════════════════════════════════════════
     SUCHE
  ═══════════════════════════════════════════════════════ */
  function initSearch(){
    var inp=document.getElementById('pg-search-input');
    var resWrap=document.getElementById('pg-search-results');
    var secWrap=document.getElementById('pg-menu-sections');
    var cats=document.getElementById('pg-cattabs');
    if(!inp||!resWrap||!secWrap) return;
    inp.addEventListener('input',function(){
      var q=inp.value.trim().toLowerCase();
      if(!q){ resWrap.style.display='none'; secWrap.style.display=''; if(cats) cats.style.display=''; return; }
      if(cats) cats.style.display='none';
      secWrap.style.display='none'; resWrap.style.display='';
      var allCards=Array.from(document.querySelectorAll('.pg-card'));
      var grid=document.getElementById('pg-search-grid');
      var count=document.getElementById('pg-search-count');
      var matched=allCards.filter(function(c){
        var n=(c.querySelector('.pg-card__name')||{}).textContent||'';
        var d=(c.querySelector('.pg-card__desc')||{}).textContent||'';
        return n.toLowerCase().includes(q)||d.toLowerCase().includes(q);
      });
      if(grid){
        grid.innerHTML='';
        if(!matched.length){
          grid.innerHTML='<div style="grid-column:1/-1;text-align:center;padding:40px 20px;background:#fff;border:1px solid #E8E0D8;border-radius:14px;"><div style="font-size:40px;margin-bottom:8px">🔍</div><p style="font-size:17px;font-weight:700;margin:0">Nichts gefunden</p></div>';
        } else {
          matched.forEach(function(c){ grid.appendChild(c.cloneNode(true)); });
        }
      }
      if(count) count.textContent=matched.length+' Treffer';
    });
  }

  /* ═══════════════════════════════════════════════════════
     CART DRAWER — Qty + Remove (Event-Delegation)
  ═══════════════════════════════════════════════════════ */
  function initCartButtons(){
    document.addEventListener('click',function(e){
      var minus=e.target.closest('[data-cart-qty-minus]');
      if(minus){ var k=minus.getAttribute('data-cart-qty-minus'); var q=document.querySelector('[data-cart-qty="'+k+'"]'); pgCartChangeWithSync(k,(parseInt((q||{}).textContent)||1)-1); return; }
      var plus=e.target.closest('[data-cart-qty-plus]');
      if(plus){ var k2=plus.getAttribute('data-cart-qty-plus'); var q2=document.querySelector('[data-cart-qty="'+k2+'"]'); pgCartChangeWithSync(k2,(parseInt((q2||{}).textContent)||1)+1); return; }
      var rem=e.target.closest('[data-cart-remove]');
      if(rem){ pgCartChangeWithSync(rem.getAttribute('data-cart-remove'),0); return; }

      /* ── Upsell: "Passt dazu" Chip ── */
      var up=e.target.closest('[data-upsell-add]');
      if(up){
        e.preventDefault();
        if(up.classList.contains('is-loading')) return;
        /* Bei geschlossenem Shop nicht hinzufügen */
        var st = window.pgDelivery ? window.pgDelivery.getStatus() : null;
        if(st && !st.open){ showToast('Aktuell geschlossen – Bestellung nicht möglich'); return; }
        var vid   = parseInt(up.getAttribute('data-upsell-add'));
        var title = up.getAttribute('data-upsell-title') || 'Artikel';
        if(!vid) return;
        up.classList.add('is-loading');
        addToCart(vid, 1, function(){
          up.classList.remove('is-loading');
          up.classList.add('is-added');
          showToast(title+' hinzugefügt', 'success');
          setTimeout(function(){ up.classList.remove('is-added'); }, 1400);
          document.dispatchEvent(new CustomEvent('cart:updated'));
        });
        return;
      }
    });
  }

  /* ═══════════════════════════════════════════════════════
     VORBESTELLUNG
  ═══════════════════════════════════════════════════════ */
  function initPreorder(){
    var wrap   = document.getElementById('pg-preorder');
    if(!wrap) return;
    var nowBtn = document.getElementById('pg-pre-now');
    var latBtn = document.getElementById('pg-pre-later');
    var picker = document.getElementById('pg-preorder-picker');
    var sel    = document.getElementById('pg-preorder-slot');
    var attr   = document.getElementById('pg-preorder-attr');
    var label  = document.getElementById('pg-preorder-label');
    if(!sel || !attr) return;

    function populate(){
      var prev = sel.value;
      var slots = getSlots(); /* nutzt PG_PREORDER_LEAD_MIN (Default 120 Min = 2 Std.) */
      sel.innerHTML = slots.length
        ? slots.map(function(s){ return '<option value="'+s.value+'">'+s.label+'</option>'; }).join('')
        : '<option value="">Zurzeit keine Zeiten verfügbar</option>';
      /* Bisherige Auswahl beibehalten, falls noch verfügbar */
      if(prev){ var keep=Array.prototype.some.call(sel.options,function(o){return o.value===prev;}); if(keep) sel.value=prev; }
      return slots;
    }
    function syncAttr(){
      var val = '';
      if(window.pgPreorder.mode === 'later'){
        window.pgPreorder.time = sel.value || '';
        val = sel.value ? ('🕒 Vorbestellung: ' + sel.value) : '';
      } else {
        window.pgPreorder.time = '';
        val = '';
      }
      attr.value = val;
      /* Wunschzeit serverseitig am Warenkorb sichern → landet zuverlässig in der Bestellung */
      fetch('/cart/update.js', {
        method:'POST',
        headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
        body: JSON.stringify({ attributes: { 'Wunschzeit': val } })
      }).catch(function(){});
      if(window.pgUpdateCheckout) window.pgUpdateCheckout();
    }
    function setMode(mode){
      window.pgPreorder.mode = mode;
      if(nowBtn) nowBtn.classList.toggle('pg-preorder__pill--active', mode==='now');
      if(latBtn) latBtn.classList.toggle('pg-preorder__pill--active', mode==='later');
      if(picker) picker.style.display = (mode==='later') ? 'block' : 'none';
      syncAttr();
    }
    if(nowBtn) nowBtn.addEventListener('click', function(){ setMode('now'); });
    if(latBtn) latBtn.addEventListener('click', function(){ setMode('later'); });
    sel.addEventListener('change', syncAttr);

    var _lastOpen = null;
    function syncOpenState(){
      var open = !window.pgDelivery || window.pgDelivery.getStatus().open;
      populate();                         /* Slots aktualisieren (Auswahl bleibt erhalten) */
      if(open === _lastOpen) return;      /* kein Statuswechsel → Modus nicht anfassen */
      _lastOpen = open;
      if(open){
        wrap.classList.remove('pg-preorder--closed');
        if(nowBtn) nowBtn.style.display = '';
        if(label) label.textContent = 'Zeitpunkt';
        setMode('now');
      } else {
        /* Geschlossen → Vorbestellung ist die einzige Option */
        wrap.classList.add('pg-preorder--closed');
        if(nowBtn) nowBtn.style.display = 'none';
        if(label) label.textContent = 'Wir haben geschlossen — jetzt vorbestellen:';
        setMode('later');
      }
    }
    syncOpenState();
    setInterval(syncOpenState, 30000);
  }

  /* ═══════════════════════════════════════════════════════
     INIT
  ═══════════════════════════════════════════════════════ */
  /* ═══════════════════════════════════════════════════════
     CART ÖFFNEN — robust, additiv, Theme-freundlich
     Öffnet den Warenkorb-Drawer zuverlässig — egal ob die Theme-eigene
     Popup-Init durchlief oder nicht. Wichtig: Wir blockieren den Klick NICHT
     pauschal. Erst PRÜFEN wir, ob das Theme nach kurzer Zeit selbst geöffnet
     hat; nur falls NICHT, öffnen wir per Fallback (gleiche Klassen wie Theme).
     So kann unser Code das Theme nicht „totlegen" (Fehler der v34-Version).
  ═══════════════════════════════════════════════════════ */
  function pgCartStage(){ return document.querySelector('[data-popup-stage="cart"]'); }
  function pgCartIsOpen(){ var s=pgCartStage(); return !!(s && s.classList.contains('is-open')); }
  function pgOpenCartDirect(){
    var stage = pgCartStage();
    if(!stage) return false;
    stage.classList.add('transition-ready');
    stage.classList.add('is-open');
    try{
      var y = window.pageYOffset || 0;
      stage.setAttribute('data-pg-scroll-y', String(y));
      document.body.style.top = '-' + y + 'px';
      document.body.classList.add('prevent-scrolling');
    }catch(_){}
    try{ var f = document.querySelector('[data-popup-focus="cart"]'); if(f) f.focus(); }catch(_){}
    return true;
  }
  function pgCloseCartDirect(){
    var stage = pgCartStage();
    if(!stage) return;
    stage.classList.remove('is-open');
    try{
      document.body.classList.remove('prevent-scrolling');
      document.body.style.removeProperty('top');
      var y = parseInt(stage.getAttribute('data-pg-scroll-y'), 10);
      if(!isNaN(y)) window.scrollTo(0, y);
    }catch(_){}
  }
  function pgInitCartOpen(){
    /* Delegierter Klick auf den Warenkorb-Button. KEIN preventDefault —
       das Theme darf seinen eigenen Handler ungestört ausführen. Wir prüfen
       nur kurz danach nach, ob der Drawer offen ist; falls nicht → Fallback. */
    document.addEventListener('click', function(e){
      var opener = e.target.closest('[data-popup-open="cart"]');
      if(!opener) return;
      if(pgCartIsOpen()) return;            /* schon offen → nichts tun */
      /* dem Theme einen Tick Zeit geben, selbst zu öffnen; öffnet es nicht,
         öffnen wir selbst. So geht der Cart IMMER auf — egal ob die Theme-
         Popup-Init lief oder nicht. */
      setTimeout(function(){ if(!pgCartIsOpen()) pgOpenCartDirect(); }, 80);
    }, false);
    /* Sicherheitsnetz: ein evtl. offenes Cookie-Overlay (liegt mit hohem
       z-index über allem) NICHT den Cart-Button-Klick verschlucken lassen.
       Wenn der Nutzer den Warenkorb anvisiert, ist die Cookie-Wahl zweitrangig. */

    /* Schließen über Overlay / X-Button / ESC — nur wenn WIR per Fallback offen
       sind (Theme bindet seine eigenen Close-Handler selbst, die bleiben aktiv). */
    document.addEventListener('click', function(e){
      if(!e.target.closest('[data-popup-close="cart"]')) return;
      setTimeout(function(){ if(pgCartIsOpen()) pgCloseCartDirect(); }, 60);
    }, false);
    document.addEventListener('keyup', function(e){
      if((e.key||'').toLowerCase()==='escape' && pgCartIsOpen()) pgCloseCartDirect();
    });
  }

  function init(){
    /* Jede Init-Funktion einzeln kapseln: ein Fehler in EINER darf die anderen
       NICHT mitreißen (sonst riss ein Crash die ganze Kette mit). */
    function safe(name, fn){ try{ fn(); }catch(e){ console.error('[PG] init '+name+' fehlgeschlagen:', e); } }
    safe('cartOpen',    pgInitCartOpen);   /* robuster Cart-Öffner (Theme zuerst, sonst Fallback) */
    safe('cartButtons', initCartButtons);
    safe('statusBar',   updateStatusBar);
    setInterval(function(){ safe('statusBar', updateStatusBar); }, 30000);
    safe('zoneModal',   initZoneModal);
    safe('optModal',    initOptModal);
    safe('catTabs',     initCatTabs);
    safe('search',      initSearch);
    safe('preorder',    initPreorder);
    fetch('/cart.js').then(function(r){return r.json();}).then(updateCartCounts).catch(function(){});
    /* Live-Bestell-Stopp (vom Tablet-Button): sofort UI aktualisieren wenn sich der Status ändert */
    document.addEventListener('pg:status-refresh', function(){
      try{ updateStatusBar(); }catch(e){}
      try{ if(typeof refreshAddButtons==='function') refreshAddButtons(); }catch(e){}
    });
  }

  document.readyState==='loading'
    ? document.addEventListener('DOMContentLoaded',init)
    : init();

})();
